import {initWebComponent} from "@/helpers/web-component-helper";
import {WizardComponent} from "@/components/wizard/wizard-component";
import {LayoutTopNavBarComponent} from "@/components/layout/layout-top-nav-bar-component";
import {GuidelinesComponent} from "@/components/guidelines/guidelines-component";
import {getCategoryName, getWebsiteName, getWebsiteUrl} from "@/helpers/url-helper";

const template = document.createElement('template');
template.innerHTML = `
<div class="layout-wrapper">
    <div class="layout-container">
        <layout-top-nav-bar></layout-top-nav-bar>
    </div>
   <div class="layout-inner">
        <div class="layout-content">
            <melding-wizard class="layout-page d-none"></melding-wizard>
        </div>
    </div>
</div>
`;

export class LayoutComponent extends HTMLElement {
    constructor() {
        super();

        const url = this.getAttribute('url')
        const website = this.getAttribute('website')
        const category = this.getAttribute('category')

        if(url !== null) {
            window.kaartViewerUrl = url
        }
        if(website !== null) {
            window.websiteName = website
        }
        if(category !== null) {
            window.categoryName = category
        }

        initWebComponent(this, template)

        this.querySelector('melding-wizard').classList.remove('d-none')
    }
}

window.customElements.define("melding-wizard", WizardComponent);
window.customElements.define("layout-top-nav-bar", LayoutTopNavBarComponent);
window.customElements.define("page-guidelines", GuidelinesComponent);

